import {Button, Flex, Input, Tabs} from "antd";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import Title from "antd/es/typography/Title";
import {Cover} from "../../components/Cover";
import {saveUser} from "../../feature/project/userSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpFromBracket, faRotate, faUpload} from "@fortawesome/free-solid-svg-icons";

export const ProfileSettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const user = useAppSelector(state => state.users.currentUser)
    const [loading, setLoading] = useState(false)
    const [avatar, setAvatar] = useState<string | undefined>(user?.avatar)
    const [email, setEmail] = useState<string | undefined>(user?.email)
    const [name, setName] = useState<string | undefined>(user?.name)

    useEffect(() => {
        setAvatar(user?.avatar)
        setEmail(user?.email)
        setName(user?.name)
    }, [user]);

    useEffect(() => {
        props.saveFunction(() => dispatch(saveUser({avatar: avatar, name: name})))
    }, [avatar, name]);

    return (
        <Flex vertical={true} gap={10}>
            <Title level={5} style={{margin: 0, paddingTop: 10}}>Profile Settings</Title>
            <Flex gap={10}>
                <Cover
                    root={user?.id + "/"}
                    style={{position: "relative", height: 200, width: 200, alignSelf: 'center'}}
                    cover={avatar}
                    editable={true}
                    uploadText={<FontAwesomeIcon icon={faArrowUpFromBracket}/>}
                    onFileUploaded={(cover) => {
                        setAvatar(cover)
                    }}
                />
                <Flex style={{paddingTop: 6}} gap={20} vertical={true}>
                    <b>Name:</b>
                    <b>E-mail:</b>
                </Flex>
                <Flex style={{flexGrow: 1}} gap={10} vertical={true}>
                    <Input value={name} onChange={(e) => {
                        setName(e.target.value)
                    }}/>
                    <Input value={email} disabled={true} onChange={(e) => {
                        setEmail(e.target.value)
                    }}/>
                </Flex>
            </Flex>
        </Flex>
    )

}